import React from "react";
import { Helmet } from "react-helmet";
import "./LegalPages.css";

export const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - WTFHoroscope</title>
        <meta name="description" content="Privacy Policy for WTFHoroscope. We don't collect personal data." />
        <meta name="robots" content="index, follow" />
        <canonical href="https://wtfhoroscope.com/privacy-policy" />
      </Helmet>

      <div className="legal-page">
        <div className="container">
          <h1 className="legal-title">Privacy Policy</h1>

          <section className="legal-section">
            <h2>What Data We Collect</h2>
            <p>
              <strong>The honest truth?</strong> We don't actually store any of your personal data.
              Zero. Nada. Zilch.
            </p>
            <p>
              When you use WTFHoroscope, we don't ask for your name, email, or any personal
              information. Your date of birth is used temporarily to generate your horoscope and is
              not stored on our servers.
            </p>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <ul>
              <li>Your date of birth is sent to Google's Gemini API to generate your horoscope</li>
              <li>The API response is displayed to you and then discarded</li>
              <li>We may cache your today's result locally in your browser to avoid re-generation</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Cookies & Browser Storage</h2>
            <p>
              We use localStorage to cache the horoscope predictions for the same day. This is
              purely for user convenience and to reduce API calls. No tracking cookies are used.
            </p>
            <p>
              Third-party ads may use cookies for advertising purposes. This is outside our control
              but clearly disclosed.
            </p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <h3>Google Gemini API</h3>
            <p>
              We use Google's Generative AI API to generate horoscopes. Your date of birth may be
              processed by Google's servers. See Google's privacy policy for details.
            </p>

            <h3>Advertising Networks</h3>
            <p>
              We display ads via third-party ad networks (Google AdSense, Adsterra, etc.). These
              networks may collect data about your browsing. Check their privacy policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>Your Rights</h2>
            <p>
              Since we don't collect any identifiable personal data, there's nothing to delete,
              access, or correct. Your horoscope is your own business.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              Questions about privacy? Email us at:{" "}
              <a href="mailto:privacy@wtfhoroscope.com">privacy@wtfhoroscope.com</a>
            </p>
          </section>

          <section className="legal-section">
            <h2>Last Updated</h2>
            <p>{new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
          </section>
        </div>
      </div>
    </>
  );
};
